export default __webpack_public_path__ + "static/niletto-8819b4b95bad809c4ba986913707e22c.svg";